import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";

import aboutUsHeader from "../assect/images/bg/dl_curvedimg_aboutus.png"

import Navbar from "../components/navbar";

import Footer from "../components/footer";
import axios from "axios";
import AvailableProperties from "../components/availableproperties";


import contactUsButton from "../assect/images/buttons/contactus.jpg"
import curvedBanner from "../assect/images/bg/dl_curvedimg_contactus.png";

export default function AboutUs(){
    const [isOpen, setOpen] = useState(false)
    
    return(
        <div style={{backgroundColor: "#f0eadd"}}>
        <Navbar navClass="defaultscroll sticky" logolight={true} menuClass = "navigation-menu nav-right"/>
        <div className="top-half top-half d-table w-100" style={{paddingTop:"74px"}}>
            <section className="bg-half-116" style={{backgroundImage:`url(${aboutUsHeader})`}}>
            </section>
        </div>
            
        <section className="section-mb-150">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-3"></div>
                    <div className="col-lg-3 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <div className="section-title ms-lg-5 align-content-lg-end">
                            <h2 className="mb-3" style={{fontSize: "36pt", color:"#093b38", fontFamily:"Bacasime Antique"}}>dimora</h2>
                            <h6 className="mb-0" style={{fontSize: "13pt", color: "#093b38"}}>noun</h6>
                            <h6 className="mb-0" style={{fontSize: "13pt", color: "#093b38"}}>[feminine] /di'mora/</h6>
                            <h6 className="mb-0" style={{fontSize: "13pt", color: "#093b38"}}>(casa)</h6>
                            <p className="para-desc mb-0" style={{fontSize: "13pt", color: "#093b38"}}>residence, dwelling, abode</p>
                            <p className="para-desc mb-0" style={{fontSize: "13pt", color: "#093b38"}}>Questa e la mia umile dimora</p>
                            <p className="para-desc mb-3" style={{fontSize: "13pt", color: "#093b38"}}>This is my humble abode</p>
                            <p></p>
                            <p className="para-desc mb-3" style={{fontSize: "8pt", color: "#093b38"}}>From the Italian-English dictionary</p>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <p className="para-desc mb-0" style={{fontSize: "15pt", fontFamily:"Bacasime Antique"}}>At Dimora Living, we manage our properties with pride, and provide a full-service experience for our residents, putting your comfort and needs above all else. Contact us today to see what's available.</p>
                        <Link to="/contactus"><img src={contactUsButton} alt="Contact Us" width="104" height="52" style={{marginTop: "20px"}} /> </Link>
                    </div>
                    <div className="col-lg-2"></div>
                </div>
            </div>
        </section>
        {/*<section className="section">*/}
        {/*    <div className="container">*/}
        {/*        <div className="row align-items-center">*/}
        {/*                <AvailableProperties />*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</section>*/}
        <Footer/>
        </div>
    )
}